import {useGrpcRequest} from '@aboutyou/data-fetcher';
// eslint-disable-next-line monorepo/no-internal-import
import {GetWishlistStateResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/service.types';
import {createDataStore} from '../createDataStore';
import {useFullSession} from '../userStore/useSession';
// eslint-disable-next-line monorepo/no-internal-import
import {useReductionsStateRequestParameter} from '@aboutyou/logic-components/src/features/ReductionsState/useReductionsStateRequestParameter';
// eslint-disable-next-line monorepo/no-internal-import
import {useTargetGroupIdentifier} from '@aboutyou/logic-components/src/shared-deprecated/useTargetGroupIdentifier';
import {usePersistSessionStateCallback} from '../sessionStore/session.hooks';
// eslint-disable-next-line monorepo/no-internal-import
import {WishlistService_GetWishlistStateLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/service.grpc.lazy';

const useExpensiveWishlist = () => {
  const session = useFullSession();
  const reductionsState = useReductionsStateRequestParameter();
  const targetGroup = useTargetGroupIdentifier();
  const persistSessionState = usePersistSessionStateCallback();

  return useGrpcRequest(
    WishlistService_GetWishlistStateLazy,
    {reductionsState, session: session!, targetGroup},
    {
      disabled: !session,
      onSuccess: (wishlistState?: GetWishlistStateResponse) => {
        const hasItemsInWishlist = Boolean(
          wishlistState?.wishlistState.items?.length,
        );
        // we want to delay persisting of the session state as much as possible for legal reasons
        // if an anonymous user doesn't have anything in the basket/basket/or is loggedIn, we don't need to persist the session-id
        if (hasItemsInWishlist) {
          persistSessionState();
        }
      },
    },
  );
};

const {Provider, useData: useWishlistMinimalState} =
  createDataStore<GetWishlistStateResponse>({
    defaultValue: undefined,
    useQueryHook: useExpensiveWishlist,
  });

export {Provider as WishlistStateProvider, useWishlistMinimalState};
